import type { ReactNode } from 'react';

import { Flex, Text } from 'ui';

type P = {
  subtitle: ReactNode;
  title: string;
};

const SearchItemContent = ({ subtitle, title }: P) => (
  <Flex className="global-search-item__content" vertical>
    <Text ellipsis size="medium" weight="medium">
      {title}
    </Text>
    <Text size="small" type="secondary" weight="medium">
      {subtitle}
    </Text>
  </Flex>
);

export default SearchItemContent;
